import React, { useState } from "react";
import {
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Box,
  useDisclosure,
  Flex,
  Circle,
  Stack,
  MenuItem,
  Button,
  useColorModeValue,
  useToast
} from "@chakra-ui/react";
import { COLORS } from "../constants/colors";
import ShareModal from "../pages/invite-guest/components/ShareModal";
import ShareInviteLink from "../pages/invite-guest/components/ShareInviteLink";
import http, { AUTH_ROUTES } from "../services/api";

export const CheckoutCodeModal = (props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isSuccessOpen,
    onOpen: onSuccessOpen,
    onClose: onSuccessClose
  } = useDisclosure();
  const appTextColor = useColorModeValue(COLORS.lightGrey, COLORS.white);
  const menuColor = useColorModeValue(COLORS.black, COLORS.white);
  const toast = useToast();
  const [checkoutCode, setCheckoutCode] = useState("");

  const handleGetCheckoutCode = async () => {
    try {
      console.log("Props received:", props); // Debug log
      const { userId, _id } = props;

      const response = await http.post("/user/guest-checkout", {
        guestId: _id,
        userId: userId
      });

      console.log("API Response:", response); // Debug log

      // Check success using the actual response structure
      if (response.data.result?.success) {
        const guestCode = response.data.result?.data?.guestCode;

        if (guestCode) {
          setCheckoutCode(guestCode);
          onClose(); // Close the confirmation modal
          onSuccessOpen(); // Open the success modal with the code

          // Refresh the guest list if needed
          // if (props.setRefresh) {
          //   props.setRefresh({});
          // }
        } else {
          throw new Error("No checkout code received");
        }
      } else {
        throw new Error(
          response.data.result?.message || "Failed to generate checkout code"
        );
      }
    } catch (error) {
      console.error("Checkout error:", error); // Add for debugging
      toast({
        title: "Error",
        description: "Failed to generate checkout code. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true
      });
    }
  };
  return (
    <Box>
      <MenuItem onClick={onOpen} color={menuColor}>
        Get Checkout Code
      </MenuItem>

      <Modal size="xs" isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalBody textAlign={"center"}>
            <Circle
              mx="auto"
              align="center"
              my="5"
              size="30px"
              bg="#FFF"
              color="white"
              border="1px solid #707070"
            />
            <Stack>
              <Text fontSize="lg" px="auto" fontWeight="light" color="#7A7A7A">
                Generate Checkout Code?
              </Text>

              <Text fontSize="sm" color="#7A7A7A">
                This will generate a new checkout code for the guest
              </Text>

              <Flex justify={"center"} gap="2rem" fontSize="md" pb="5">
                <Button color="#B7B6B6" onClick={onClose}>
                  Cancel
                </Button>
                <Button
                  color="#4CAF50"
                  pl="5"
                  onClick={handleGetCheckoutCode}
                >
                  Generate
                </Button>
              </Flex>
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* Success Modal with Checkout Code */}
      <ShareModal
        size="xs"
        isOpen={isSuccessOpen}
        onOpen={onSuccessOpen}
        onClose={onSuccessClose}
      >
        <ShareInviteLink onClose={onSuccessClose} guestCode={checkoutCode} />
      </ShareModal>
    </Box>
  );
};
